"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_204)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_204`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V23.9998H0V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V12H0V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.8696 5.99995C5.8696 4.25163 7.09838 2.7911 8.7392 2.43272C8.48215 2.37636 8.21977 2.34788 7.95662 2.34778C5.93949 2.34778 4.30444 3.98283 4.30444 5.99988C4.30444 8.01694 5.93956 9.65206 7.95662 9.65206C8.22535 9.65206 8.48699 9.62218 8.7392 9.56712C7.09838 9.20888 5.8696 7.74835 5.8696 5.99995ZM10.5653 2.60871L10.8243 3.40584H11.6625L10.9843 3.89852L11.2434 4.69566L10.5653 4.20305L9.88712 4.69566L10.1462 3.89852L9.46806 3.40584H10.3063L10.5653 2.60871Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.53204 4.17395L8.791 4.97108H9.6292L8.95103 5.46376L9.21007 6.2609L8.53204 5.76829L7.85388 6.2609L8.11298 5.46376L7.43481 4.97108H8.27301L8.53204 4.17395ZM12.5985 4.17395L12.8575 4.97108H13.6957L13.0176 5.46376L13.2766 6.2609L12.5985 5.76829L11.9204 6.2609L12.1795 5.46376L11.5013 4.97108H12.3395L12.5985 4.17395ZM11.8158 6.52176L12.0749 7.31889H12.9131L12.235 7.81157L12.494 8.60871L11.8158 8.11609L11.1378 8.60871L11.3969 7.81157L10.7188 7.31889H11.5569L11.8158 6.52176ZM9.31462 6.52176L9.57358 7.31889H10.4118L9.73368 7.81157L9.99272 8.60871L9.31462 8.11609L8.63653 8.60871L8.89556 7.81157L8.21746 7.31889H9.05559L9.31462 6.52176Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_204`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SGFlag };
